import styled from 'styled-components'

export const Container = styled.div`
  position: relative;
`

export const InputWrapper = styled.div`
  width: 100%;
  height: 3.25rem;
  padding: 0 16px;
  border-radius: 10px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  column-gap: 10px;
  background-color: #f3f4f8;
  cursor: text;
`

export const Tag = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: #e1f5ee;
  color: #1d9e75;
  font-size: 12px;
  font-weight: 500;
  padding: 2px 8px;
  border-radius: 12px;
  white-space: nowrap;
`

export const TagRemoveBtn = styled.span`
  cursor: pointer;
  line-height: 1;
  opacity: 0.7;
  font-size: 11px;
  &:hover {
    opacity: 1;
  }
`

export const SearchInput = styled.input`
  border: none;
  outline: none;
  font-size: 13px;
  background: transparent;
  flex: 1;
  min-width: 120px;
  color: inherit;
`

export const Dropdown = styled.div`
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  background: white;
  border: 1px solid #eee;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  z-index: 100;
  overflow: hidden;
`

export const DropdownItem = styled.div`
  padding: 9px 14px;
  font-size: 13px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  &:hover {
    background: #f5f5f5;
  }
`

export const GroupTypeBadge = styled.span<{ $isGlobal: boolean }>`
  font-size: 10px;
  padding: 1px 6px;
  border-radius: 8px;
  background: ${({ $isGlobal }) => ($isGlobal ? '#E6F1FB' : '#F1EFE8')};
  color: ${({ $isGlobal }) => ($isGlobal ? '#185FA5' : '#5F5E5A')};
`

export const CreateItem = styled.div<{ $isCreating: boolean; $hasBorder: boolean }>`
  padding: 9px 14px;
  font-size: 13px;
  cursor: ${({ $isCreating }) => ($isCreating ? 'default' : 'pointer')};
  color: #1d9e75;
  font-weight: 500;
  border-top: ${({ $hasBorder }) => ($hasBorder ? '1px solid #eee' : 'none')};
  opacity: ${({ $isCreating }) => ($isCreating ? 0.6 : 1)};
  &:hover {
    background: #f5f5f5;
  }
`
